import { Component } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../services/common.service';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-vitalreport',
  templateUrl: './vitalreport.component.html',
  styleUrls: ['./vitalreport.component.scss']
})
export class VitalreportComponent {
 iframeKey: number = Date.now();
 vitalstatsURL:SafeResourceUrl='';
 constructor(private ngxloader:NgxUiLoaderService,private service:CommonService,private sanitizer:DomSanitizer,private toastr:ToastrService) { }

ngOnInit(): void {
  this.getVitalReportUrl();
}
getVitalReportUrl(){
  let SelectedHubRole= JSON.parse(sessionStorage.getItem("selectedRole"));
  let UserID = SelectedHubRole.UserID;
  let usernamedisplay = UserID.split('@')[0].replaceAll('.', ' ');
  let obj={
    "FormattedDisplayName": usernamedisplay,
    "loginid": UserID,
    "emailId": UserID,
    "userid": SelectedHubRole.uniqueId,
    "rolename": SelectedHubRole.RoleName,
    "organizationid": "-201",
    "deploymentkey": "EXTORG",
    "source": "VitalHub"
  }
  this.ngxloader.start();
  this.service.getVitalReportUrl(obj).subscribe((res:any)=>{
    if(res?.status=='success'){
      this.vitalstatsURL = this.sanitizer.bypassSecurityTrustResourceUrl(res.responsebody);
      this.iframeKey = Date.now();
    }
    else{
      this.toastr.warning('Failed to load Vital Report URL with message :-' + res.responsebody,res.status,{
      positionClass:'toast-bottom-right',
      timeOut:4000
      });
    }
    this.ngxloader.stop();  
  },error=>{
    this.ngxloader.stop();
    this.toastr.warning('Error occured to load Vital Report URL ','Error',{
      positionClass:'toast-bottom-right',
      timeOut:4000
      });
  });
}
}
